module.exports = __webpack_public_path__ + "static/media/5750.0bf5c743.jpg";